import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ListPageComponent } from './listpage.component';
import { AuthGuard } from '../../auth/auth-guard.service';
import { CmsPageComponent } from './cmspages.component';

const routes: Routes = [
  {
    path: '',
    component: CmsPageComponent, canActivate: [AuthGuard],
    data: { permissions: ['adminAccess']},
    children: [

      {
        path: 'pages',
        component: ListPageComponent,
        canActivate: [AuthGuard],
        data: { permissions: ['adminAccess', 'adminEditUser']},
      },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CmsPagesRoutingModule { }

export const routedComponents = [
  CmsPageComponent,
  ListPageComponent
];
